import clsx from "clsx";
import {SubmitButton} from "components/Button";
import {Formik} from "formik";
import {useForgotPassword, useForgotPasswordByOtp} from "hooks/Auth";
import {useState} from "react";
import {useHistory} from "react-router-dom";
import {convertErrorMessageFormat} from "utils/converter";
import {loadLocalAssets} from "utils/loader";
import * as Yup from "yup";

const FormSchemaValidation = Yup.object().shape({
	email: Yup.string().required("Email atau nomor telepon wajib di isi"),
});
const FormInitialValues = {email: ""};

export function ForgotPassword() {
	const [successSendEmail, setSuccessSendEmail] = useState(false);
	const history = useHistory();
	const {mutate, isLoading} = useForgotPassword();
	const {mutate: forgotPassworbByOtp, isLoading: isLoadingForgotPassworbByOtp} = useForgotPasswordByOtp();
	const [errorSubmit, setErrorSubmit] = useState("");
	const handleSubmit = formData => {
		const emailSchema = Yup.object().shape({
			email: Yup.string().email(),
		});

		const isEmail = emailSchema.isValidSync(formData);

		if (isEmail) {
			mutate(formData, {
				onSuccess: () => {
					setSuccessSendEmail(true);
				},
				onError: res => {
					setErrorSubmit(convertErrorMessageFormat(res.response.status, res.response.data.message));
				},
			});
		} else {
			let phoneNumber = formData.email;

			if (phoneNumber.startsWith("0")) phoneNumber = phoneNumber.replace("0", "");
			if (phoneNumber.startsWith("62")) phoneNumber = phoneNumber.replace("62", "");
			else if (phoneNumber.startsWith("+62")) phoneNumber = phoneNumber.replace("+62", "");

			forgotPassworbByOtp(
				{phoneNumber},
				{
					onSuccess: () => {
						history.push(`/auth/verification-otp`);
					},
					onError: res => {
						setErrorSubmit(convertErrorMessageFormat(res.response.status, res.response.data.message));
					},
				},
			);
		}
	};

	return (
		<div className="change-password-wrapper">
			<div className="form-main">
				<div className="inner-fm">
					<img alt="logo" className="img-fluid mb-5" src={loadLocalAssets("img/logo.svg")} />
					{!successSendEmail && (
						<Formik
							initialValues={FormInitialValues}
							validationSchema={FormSchemaValidation}
							onSubmit={handleSubmit}>
							{({handleSubmit, handleBlur, handleChange, values, errors}) => (
								<>
									<div className="ttl-28 mb-4">Lupa Kata Sandi</div>
									<div className="label-fl mb-2">
										Masukkan alamat email Anda dan kami akan mengirimkan instruksi untuk mereset
										kata sandi
									</div>
									<div className="form-login">
										<div className="label-fl mb-2">Email Atau Nomor Telepon</div>
										<input
											className={clsx("form-control", errors?.email && "form-control-error")}
											disabled={isLoading}
											name="email"
											placeholder=""
											type="email"
											value={values?.email}
											onBlur={handleBlur}
											onChange={handleChange}
										/>
										{errors.email && <p className="form-error-item-message">{errors.email}</p>}
										{errorSubmit && <p className="form-error-item-message">{errorSubmit}</p>}
									</div>
									<SubmitButton
										className="btn btn-orange w-100"
										disabled={!FormSchemaValidation.isValidSync(values)}
										loading={isLoading || isLoadingForgotPassworbByOtp}
										text="Kirim"
										onClick={handleSubmit}
									/>
								</>
							)}
						</Formik>
					)}

					{successSendEmail && (
						<>
							<div className="ttl-28 mb-4">Lupa Kata Sandi</div>
							<div className="label-fl mb-2">
								Silakan periksa email Anda kami telah mengirim instruksi untuk merubah kata sandi
							</div>
							<SubmitButton
								className="btn btn-orange w-100"
								text="Oke"
								onClick={() => history.push("/auth/login")}
							/>
						</>
					)}
				</div>
			</div>
			<div className="img-main" style={{backgroundImage: `url(${loadLocalAssets("img/bg-login.jpg")})`}} />
		</div>
	);
}
